<template src="./template.html"></template>
<style src="./groups.scss" lang="scss"></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import TopicSuggestions from '@/components/modules/group/TopicSuggestions'
  import CreateGroupOverlay from '@/components/overlays/group/CreateGroupOverlay'
  import GroupInvitations from '@/components/modules/group/GroupInvitations'
  import GroupGallery from '@/components/modules/group/GroupGallery'

  export default {
    name: 'GroupsPage',
    components: {
      GroupGallery,
      GroupInvitations,
      CreateGroupOverlay,
      TopicSuggestions,
    },
    data() {
      return {
        createGroupOverlay: false,
        timer: null,
        statusMessage: null,
        isStatusVisible: false,
        type: 'groups',
      }
    },
    metaInfo() {
      return {
        title: this.$t('meta.groups.title'),
      }
    },
    computed: {
      ...mapState('groups', [
        'groups',
        'publicGroups',
        'groupInvitations',
        'groupApplications',
        'permissions',
      ]),
      ...mapState('topics', ['topicSuggestions']),
      ...mapState('auth', ['settings']),
    },
    created() {
      this.loadData()
      this.getTopicSuggestions()
      this.timer = setInterval(this.loadData, 60000)
    },
    destroyed() {
      clearInterval(this.timer)
      this.clearGroups()
    },
    methods: {
      ...mapActions('groups', [
        'getGroups',
        'getGroupInvitations',
        'getGroupApplications',
        'getPublicGroups',
        'acceptInvitation',
        'declineInvitation',
        'acceptRequest',
        'declineRequest',
        'clearGroups',
        'createGroup',
        'leaveGroup',
      ]),
      ...mapActions('topics', [
        'getTopicSuggestions',
        'acceptSuggestion',
        'declineSuggestion',
      ]),
      ...mapActions('auth', ['getRoutes']),
      loadData() {
        this.getGroups(this.type)
        this.getGroupInvitations(this.type)
        this.getGroupApplications()
        this.getPublicGroups()
        this.getRoutes()
      },
      closeOverlay() {
        this.createGroupOverlay = false
      },
      submitGroup(args) {
        this.createGroup(args).then(_ => {
          this.statusMessage = this.$t(this.successStatusTranslation('group', 'create'))
          this.isStatusVisible = true
          this.createGroupOverlay = false
          this.getGroups(this.type)
          this.getGroupInvitations()
          this.getGroupApplications()
        })
      },
      onAcceptInvitation(id, type) {
        type === 'invitation' ?
        this.acceptInvitation(id).then(_ => this.loadData()) :
        this.acceptRequest(id).then(_ => {
          this.statusMessage = this.$t(this.successStatusTranslation('group', 'accept_invitation'), { name: '%s' })
          this.isStatusVisible = true
          this.loadData()
        })
      },
      onDeclineInvitation(id, type) {
        type === 'invitation' ?
        this.declineInvitation(id).then(_ => this.loadData()) : this.declineRequest(id).then(_ => this.loadData())
      },
      onAcceptSuggestion(id) {
        this.acceptSuggestion(id).then(_ => this.getTopicSuggestions())
      },
      onDeclineSuggestion(id) {
        this.declineSuggestion(id).then(_ => this.getTopicSuggestions())
      },
      isAllowed() {
        return this.permissions.includes('create')
      },
    },
  }
</script>
